module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kpipa_m2.224b4a7acda53e5a6ac85ad7277e5220.png";